// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleImageModal_container__1xfcc","img":"SimpleImageModal_img__2Hzqj"};